import { Reducer } from 'redux';

import { FLOAT_MESSAGE, TOAST } from 'store/actions/toast.action';
import { Action } from 'types/Action';
import { Toast } from 'types/store/Toast';

const initState: Toast = {
  message: '',
  type: 'success',
  open: false,
  headline: '',
  text: '',
  isOpen: false,
  isHtml: false
};

const ToastReducer: Reducer<Toast, Action> = (
  state = initState,
  { type, payload },
) => {
  switch (type) {
    case TOAST.TOAST_OPEN: {
      return {
        ...state,
        message: payload.message,
        type: payload.type,
        open: true,
        headline: payload.headline ? payload.headline : payload.type,
        isHtml: payload.isHtml ? payload.isHtml : false
      }
    }
    case TOAST.TOAST_CLOSE: {
      return {
        ...state,
        message: '',
        open: false,
        isHtml: false,
      }
    }
    case FLOAT_MESSAGE.FLOAT_MESSAGE_OPEN: {
      return {
        ...state,
        text: payload.message,
        isOpen: true,
        isHtml: false,
      }
    }
    case FLOAT_MESSAGE.FLOAT_MESSAGE_CLOSE: {
      return {
        ...state,
        isOpen: false,
        isHtml: false,
      }
    }
    default: {
      return state;
    }
  }
};

export default ToastReducer;
